import Nav from 'react-bootstrap/Nav';
import Badge from 'react-bootstrap/Badge';

import { Typography } from '@material-ui/core';
import { useStyles } from '../theme';

const styles = (theme) => ({
  navItem: {
    display: 'flex',
    '&:hover': {
      '--bs-nav-link-hover-color': '#008383'
    }
  },
  navLink: {
    minWidth: 150,
    paddingLeft: '20px !important',
    paddingRight: '20px !important',
    justifyItems: 'center'
  },
  countBadge: {
    fontWeight: 500,
    verticalAlign: 'text-bottom',
    marginLeft: 8,
    fontSize: '13px',
    letterSpacing: '1.98px',
    padding: '5px 8px',
    backgroundColor: '#E6F8F8 !important',
    color: '#008383'
  }
});

export const TabItem = ({ tab }) => {
  const classes = useStyles(styles);

  return (
    <>
      <style type="text/css">
        {`
          .nav-link.active {
            border-bottom: #008383 4px solid !important;
            .badge {
              color: white;
              background-color: #008383 !important;
            }
          }
      `}
      </style>
      <Nav.Item className={`${classes.navItem} border-0`}>
        <Nav.Link
          disabled={tab.boardCount === 0}
          eventKey={tab.id}
          className={classes.navLink}
        >
          <Typography variant="body1" style={{ color: 'grey' }}>
            {tab.displayName}{' '}
            <Badge className={`rounded-pill ${classes.countBadge}`}>
              {tab.boardCount}
            </Badge>
          </Typography>
        </Nav.Link>
      </Nav.Item>
    </>
  );
};
